import { render } from "./InfoActions.vue?vue&type=template&id=56d1a4ab&scoped=true"
import script from "./InfoActions.vue?vue&type=script&lang=js"
export * from "./InfoActions.vue?vue&type=script&lang=js"

import "./InfoActions.vue?vue&type=style&index=0&id=56d1a4ab&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d1a4ab"]])

export default __exports__